import { useSearchParams } from 'react-router';
import ListService from './ListService';
import LayoutAdmin from '../../components/layouts/LayoutAdmin';
import FormService from './FormService';

export default function Service() {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'list';

  return (
    <LayoutAdmin header="Service">
      {activeTab === 'list' && <ListService />}
      {activeTab === 'form' && <FormService />}
    </LayoutAdmin>
  );
}
